<template>
	<el-card>
		<div slot="header" class="appointment header">
			<img src="../image/appointment_new.png" class="header-icon">
			<span class="header-title">Appointments</span>

			<el-dropdown v-if="profileAppointments.length > 0" @command="sendAppointment" class="appointment-send">
				<span class="el-dropdown-link" v-if="getUserType !== 'observer'">
					Send New
					<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown" style="margin:-8px -8px 0 0">
					<el-dropdown-item v-for="(a, index) in profileAppointments" :key="index" :command="a.id">
						{{ a.title }}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<el-cascader
				v-if="showMultiProviders"
				class="appointment-cascader"
				v-model="selectedProviderAppointment"
				:options="multiProviderAppointmentList"
				@change="handleAppointmentChange"
				>
			</el-cascader>
		</div>
		<AppointmentTable :patient="patient" v-bind:appointments="appointments"></AppointmentTable>

		<el-dialog
		  title="Send appointment"
		  :visible.sync="sendNew"
		  :append-to-body="true"
		  custom-class="test"
		  width="30%">

		  <p class="preview">
			  <img :src="getIconImage('appointment')">
			  {{ getContentKey('appointment', sendId, 'title') }}
		  </p>
		  <el-input type="textarea" v-model="sendMessage"></el-input>

		  <span slot="footer" class="dialog-footer">
		    <el-button @click="resetSendAppointment">Cancel</el-button>
		    <el-button type="primary"
				@click="confirmSendAppointment"
				v-bind:disabled="sending">Send</el-button>
		  </span>
		</el-dialog>
	</el-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import OverviewCard from '..'
import AppointmentTable from './Table'

const DEFAULT_MESSAGE = 'Please plan for your upcoming appointment.'

export default {
	name: 'patient-appointment-card',
	extends: OverviewCard,

	data() {
		return {
			sendId: null,
			sendNew: false,
			sendMessage: DEFAULT_MESSAGE,
			selectedProviderAppointment: []
		}
	},

	methods: {
		...mapActions('provider', [
			'createPatientMessage'
		]),
		sendAppointment(id) {
			this.sendId = id
			this.sendNew = true
		},
		confirmSendAppointment(id) {
			this.sendNew = false
			let messageData = {
				patient: this.patient.id,
				text: this.sendMessage,
				ref_type: 'appointment',
				ref_id: this.sendId
			}
			if(this.showMultiProviders && this.selectedProviderAppointment.length > 0)
				messageData.provider = this.selectedProviderAppointment[0].split(':')[0]
			else if (this.allPatientsChosen && this.patientProviderProfileList.length === 1)
				messageData.provider = this.patientProviderProfileList[0].provider
			else
				messageData.provider = null

			this.createPatientMessage(messageData)
		},
		resetSendAppointment() {
			this.sendNew = false
			this.sendMessage = DEFAULT_MESSAGE
		},
		handleAppointmentChange(apptValue) {
			if(Array.isArray(apptValue) && apptValue.length === 2)
				this.sendAppointment(apptValue[1])
		}
	},

	computed: {
		...mapGetters('provider', [
			'getPatientMessages',
			'getPatientMessagingState',
			'getProvidersIdArray',
			'getProviderNameById',
			'allPatientsChosen',
			'getPatientProviderProfileList'
		]),
		...mapGetters('content', [
			'getProfileContent'
		]),
		...mapGetters(['getUserType']),
		patientProviderProfileList() {
			return this.getPatientProviderProfileList(this.patient.id)
		},
		sending() {
			return this.getPatientMessagingState(this.patient.id)
		},
		profileAppointments() {
			var appointments = []
			this.patientProviderProfileList.map(({ profile }) => {
				let p = this.getContent('profile', profile)
				if (p && p.appointment && this.getContent('appointment', p.appointment)) {
					appointments.push.apply(appointments, this.getContent('appointment', p.appointment))
				}
			})
			return appointments
		},
		appointments() {
			return this.patientEventType('appointment')
		},
		showMultiProviders() {
			return this.allPatientsChosen && (this.patientProviderProfileList.length > 1)
		},
		multiProviderAppointmentList() {
			try {
				return this.patient.profile_map
					.filter((providerProfile) => this.getProvidersIdArray.includes(providerProfile.split(':')[0]))
					.map((providerProfile) => {
						const [providerId, profileId ] = providerProfile.split(':')
						const value = providerProfile,
							label = `${this.getProviderNameById(providerId)} (${this.getContentKey('profile', profileId, 'title')})`
						const children = this.getProfileContent(profileId, 'appointment').map(({ id, title }) => ({ value: id, label: title }))
						return {
							value,
							label,
							children
						}
					})
			} catch (error) {
				console.error('Problem Calculating multiProviderQuestionnaireList ', error)
				return []
			}
		}
	},

	components: {
		AppointmentTable
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
.el-card .appointment-send.el-dropdown {
	width: 100px;
	margin-right: 0;
	font-size: 12px;
	padding: 0 10px;
	background-color: $appointment-color;
	color: $white-color;
	.el-dropdown-link {
		padding: 0px;
		font-weight: 500;
	}
}
.el-cascader.appointment-cascader {
	position: absolute;
	right: 0;
	width: 100px;
	opacity: 0;
	height: 40px;
	line-height: 40px;
	.el-input__inner {
		height: 40px;
	}
}
</style>
